// import fly from "./fly";
import fly from "flyio";
const api = {
  membercardInterestDesc: (r) => fly.get('/api/member/membercardInterestDesc.json', r),
  tfGetConfig: (r) => fly.get('/api/tfMember/getConfig.json', r),
  tfGetMemberInfo: (r) => fly.get('/api/tfMember/getMemberInfo.json', r),
  cpWechatLikeActivityLike: r => fly.get('/api/cpwechat/likeActivity/like.json', r),
  getCpWechatLikeActivityContent: r => fly.get('/api/cpwechat/likeActivity/getContent.json', r),
  bindCustomer: r => fly.post('/cpwechatapi/welcomeCouponRecord/bindCustomer', r),
  topList: r => fly.get('/cpwechatapi/weTaskFissionRecord/topList', r),
  taskInfo: r => fly.get('/cpwechatapi/weTaskFissionRecord/taskInfo', r),
  findHotelByCondition: r => fly.post('/api/hotel/findHotelByCondition.json', r),
  // 获取广告
  getScrollPic: (r) => fly.get('/api/shop/getScrollPic.json', r),
  // 获取广告
  listScrollPic: (r) => fly.get('/api/shop/listScrollPic.json', r),
  // 获取商城模块
  getListType: (r) => fly.get('/api/shop/getShopModule.json', r),
  // 商品分类列表
  //秒杀列表
  secondRush: (r) => fly.get('/api/shop/secondRush.json', r),
  // 商品分类列表
  listGoodsType: (r) => fly.get('/api/shop/listGoodsType.json', r),
  findByDomain: r => fly.get("/api/cache/clientRegister/findByDomain.json", r),
  buildSignature: r => fly.post("/api/wechat/platform/jssdk/buildSignature.json", r),
  authUrl: r => fly.get("/api/wechat/platform/jssdk/authUrl.json", r),
  oauthForMember: r => fly.get("/api/wechat/platform/user/oauthForMember.json", r),
  // 父商品分类和分类下商品接口
  goodsTypeIndex: (r) => fly.get('/api/shop/goodsTypeIndex.json', r),
  // 商品列表
  listGoods: (r) => fly.get('/api/shop/listGoods.json', r),
  memberLoginOpen: (r) => fly.get('/api/member/memberLoginOpen.json', r),
  memberLogin: (r) => fly.post('/api/member/memberLogin.json?' + r.url, r.url),
  memberLoginByMobileCode: (r) => fly.post('/api/member/memberLoginByMobileCode.json?' + r.url, r.url),
  getWxCode: (r) => fly.get('/api/microSoftWare/getOpenidSessionKey.json', r),
  removeOpenId: (r) => fly.post("/api/member/removeOpenId.json?", r),
  verifyCode: (r) => fly.get('/api/member/createIdentifyCode.json', r),
  fastRegister: (r) => fly.post('/api/member/fastRegister.json', r.url),
  bindOpenId: (r) => fly.get('/api/member/bindOpenId.json', r),
  update: (r) => fly.post('/api/member/updateMemberBaseInfo.json?hotelGroupId=' + r.hotelGroupId, r),
  // 商品详情
  goodsDetail: (r) => fly.get('/api/shop/goodsDetail.json', r),
  // 获取商品的sku信息
  goodsSku: (r) => fly.get('/api/shop/goodsSku.json', r),
  // 我的购物车
  listShopCart: (r) => fly.get('/api/shop/listShopCart.json', r),
  // 添加购物车
  saveShopCart: (r) => fly.post('/api/shop/saveShopCart?' + r.url, r),
  // 删除购物车商品
  deleteShopCart: (r) => fly.post('/api/shop/deleteShopCart.json?' + r.url, r),
  // 修改购物车
  updateShopCart: (r) => fly.post('/api/shop/updateShopCart.json?' + r.url, r),
  // 父商品分类下面的子分类
  listGoodsTypeSon: (r) => fly.get('/api/shop/listGoodsTypeSon.json', r),
  // 检测商品最大购买数
  checkLimitBuy: (r) => fly.post('/api/shop/checkLimitBuy.json', r),
  // 地址
  shippingAddress: (r) => fly.get('/api/member/shippingAddress.json', r),
  // 配送方式显式校验& 发票显示
  checkDeliveryLimitShow: (r) => fly.post('/api/shop/checkDeliveryLimitShow.json', r),
  // 酒店负责人，自提、客房配送，酒店列表
  listShopHotelManager: (r) => fly.get('/api/shop/listShopHotelManager.json', r),
  // 运费接口
  deliveryPrice: (r) => fly.post('/api/shop/deliveryPrice.json', r),
  // 支付订单
  pay: (r) => fly.post('/api/shop/pay.json', r),
  // 提交订单
  submitOrder: (r) => fly.post('/api/shop/submitOrder.json', r),
  //获取优惠价格
  goodsDiscountPrice: (r) => fly.post('/api/shop/goodsDiscountPrice.json', r),
  // 查询第三方订单状态
  orderQuery: (r) => fly.get('/api/shop/orderQuery.json', r),
  // 取消支付
  cancelPay: (r) => fly.post('/api/shop/cancelPay.json?orderNo=' + r.orderNo, r),
  // 自由行普通商品申请退款
  oderRefund: (r) => fly.post('/api/shop/oderRefund.json?' + r.url, r),
  // 获取订单列表
  listMyOrder: (r) => fly.post('/api/shop/listMyOrder.json?' + r.url, r),
  cancelOrder: (r) => fly.post('/api/shop/cancelOrder.json?' + r.url, r),
  confirmRece: (r) => fly.post('/api/shop/confirmRece.json?' + r.url, r),
  orderDetail: (r) => fly.get('/api/shop/orderDetail.json', r),
  getCouponCodeList: (r) => fly.get('/api/member/findCouponDetailListByMemberId.json', r),
  getCouponByNo: (r) => fly.get('/api/member/getCouponByNo.json', r),
  listPoint: (r) => fly.get('/api/member/listPoint.json', r),
  //转赠
  transferShare: (r) => fly.post('/api/shop/transferShare.json', r),
  //转赠信息接口
  transferShareInfo: (r) => fly.get('/api/shop/transferShareInfo.json', r),
  //领取转赠接口
  receiveTransferShare: (r) => fly.post('/api/shop/receiveTransferShare.json', r),
  // 转赠的接口
  presentGiftCoupon4Platform: r => fly.get("/api/coupon/presentGiftCoupon4Platform.json", r),
  // 接受转赠的接口
  receiveGiftCoupon4Platform: r => fly.get("/api/coupon/receiveGiftCoupon4Platform.json", r),
  getMultiSysOptionCommon: (r) => fly.get('/api/cache/sysOptions/getMultiSysOptionCommon.json', r),
  // 优惠券领取接口
  receiveSCCoupon: (r) => fly.post('/api/shop/receiveSCCouponNew.json?' + r, r),
  // 结算页面查询可用优惠券列表
  getAvailableCoupon: (r) => fly.post('/api/shop/getAvailableCoupon?hotelGroupCode=' + r.hotelGroupCode + '&hotelGroupId=' + r.hotelGroupId, r),
  editInfo: (r) => fly.put('/api/member/info.json?' + r.url, r),
  verifyIdentifyCode: (r) => fly.get('/api/member/verifyIdentifyCode.json', r),
  quesyShopConfig: (r) => fly.get('/api/shop/quesyShopConfig.json', r),
  getCouponShareByShopCode: (r) => fly.get('/api/coupon/getCouponShareByShopCode.json', r),
  // 核销码扫描轮询接口
  queryCouponNoStatus: (r) => fly.get('/api/shop/queryCouponNoStatus.json', r),
  // 微信小程序加密数据解密
  decrypt: (r) => fly.get('/api/wxMiniApp/decrypt.json', r),
  // 微信会员完善资料成为会员
  upWeiXin: (r) => fly.post('/api/member/updateMemberInfoForWeiXin.json', r),
  // 删除地址
deleteAddress: (r) =>
    fly.get('/api/member/deleteShippingAddress.json', r),
  // 获取会员地址
  getMemberAddress: (r) => fly.get('/api/member/shippingAddress.json', r),
  // 设置默认收货地址
  setDefaultAddress: (r) => fly.post('/api/member/shippingAddress/default.json?memberId=' + r.memberId + '&id=' + r.id, r),
  // 新增收货地址
  addAddress: (r) => fly.post('/api/member/shippingAddress.json', r),
  // 查询订单物流信息
  deliveryMessageAjax: (r) => fly.get('/api/shop/deliveryMessageAjax.json', r),
  // 首页的抢购信息
  findNowFlashSale: (r) => fly.get('/api/shop/findNowFlashSale.json', r),
  // 取消订阅限时抢购
  cancelFlashNotify: (r) => fly.get('/api/shop/cancelFlashNotify.json', r),
  // 订阅提醒
  addShopFlashNotify: (r) => fly.post('/api/shop/addShopFlashNotify.json', r),
  // 限时抢购配置
  findShopFlashConfig: (r) => fly.get('/api/shop/findShopFlashConfig.json', r),
  // 限时抢购商品详情
  flashGoodsDetail: (r) => fly.get('/api/shop/flashGoodsDetail.json', r),
  // 抢购场次下的商品
  findShopFlashGoodsAjax: (r) => fly.get('/api/shop/findShopFlashGoodsAjax.json', r),
  // 自由行限时抢购最大购买数验证
  checkFlashGoodsLimitBuy: (r) => fly.get('/api/shop/checkFlashGoodsLimitBuy.json', r),
  // 拼团商品列表
  findShopGroupList: (r) => fly.get('/api/shop/findShopGroupList.json', r),
  //  拼团须知与轮播图
  groupOrderKnow: (r) => fly.get('/api/shop/groupOrderKnow.json', r),
  // 拼团商品详情
  getShopGroupDetail: (r) => fly.get('/api/shop/getShopGroupDetail.json', r),
  // 获取拼团详情
  shopGroupBookDetail: (r) => fly.get('/api/shop/shopGroupBookDetail.json', r),

  // 支付订单占位操作
  ShopGroupCancelPay: (r) => fly.post('/api/shop/cancelPay.json', r),
  // 获取积分支付规则
  getPointPayConfig: (r) => fly.get('/api/hotel/getPointPayConfig.json', r),
  // 获取评价列表
  listComment: (r) => fly.get('/api/shop/listComment.json', r),
  checkCouponCount: (r) => fly.get('/api/shop/checkCouponCount.json', r),
  // 上传评论图片
  syncUploadImageByWechat: (r) => fly.get('/api/shop/syncUploadImageByWechat.json', r),
  // 商品订单点评添加
  addComment: (r) => fly.post('/api/shop/addComment.json', r),
  // 储值卡支付
  chuzhiPay: (r) => fly.post('api/shop/pay.json', r),
  //立减优惠接口
  cutPrice: (r) => fly.get('api/shop/goodsDetail.json', r),
  //获取商品视频
  getGoodsVideo: (r) => fly.get('/api/shop/getGoodsVideo.json', r),
  //修改储值卡支付密码
  changeCardPass: (r) => fly.get('/api/member/changeCardPass.json', r),

  memberLoginByMobileAndOpenId: (r) => fly.get('/api/member/memberLoginByMobileAndOpenId.json', r),
  //根据openid获取微信用户信息
  getWxUser: (r) => fly.get('/api/wechat/platform/user/userInfo.json', r),
  wechatAccountInf: (r) => fly.get('/api/wechat/platform/wechatAccountInf.json', r),
  // 评价上传图片
  syncUploadImageByMiniProgram: (r) => fly.post('/api/shop/syncUploadImageByMiniProgram.json', r),

  //出行人添加，修改
  saveShopTravelPersons: (r) => fly.post('/api/shop/saveShopTravelPersons.json?type=' + r.cardType, r),
  //出行人列表
  getShopTravelPersons: (r) => fly.get('/api/shop/getShopTravelPersons.json', r),
  //删除出行人
  delTravelPerson: (r) => fly.get('/api/shop/delTravelPerson.json', r),
  //获取第三方openid
  getDistributorByOpenid: (r) => fly.post('/api/shop/getDistributorByOpenid.json' + r, r),
  //获取小程序码
  getWxacodeUnlimitUrl: (r) => fly.get('/api/microSoftWare/admin/getWxacodeUnlimitUrl.json', r),
  edmVerify: (r) => fly.get('/api/member/edmVerify.json', r),
  changeMemberPass: (r) => fly.post('/api/member/changeMemberPass.json', r),
  memberInvoice: (r) => fly.get('/api/member/memberInvoice.json', r),
  memberInvoiceInfo: (r) => fly.get('/api/member/memberInvoiceInfo.json', r),
  deleteMemberInvoice: (r) => fly.get('/api/member/deleteMemberInvoice.json', r),
  saveOrUpdateMemberInvoice: (r) => fly.post('/api/member/saveOrUpdateMemberInvoice.json', r),
  getInvoiceAmountAndMsg: (r) => fly.get('/api/invoice/getInvoiceAmountAndMsg.json', r),
  saveOrUpdateOrderInvoice: (r) => fly.get('/api/invoice/saveOrUpdateOrderInvoice.json', r),

  applyInvoice: (r) => fly.get('/api/invoice/applyInvoice.json', r),
  //根据集团码，酒店码，酒店名称模糊 查询酒店集合
  searchHotels: (r) => fly.get(' /api/hotel/searchHotels.json', r),
  getActivityDesc: (r) => fly.get(' /api/shop/getActivityDesc.json', r),
  batchQueryShopConfig: (r) => fly.get(' /api/shop/batchQueryShopConfig.json', r),
  // 查询票券平台优惠券
  listCouponWithHistoryByCardNo: r => fly.get("/api/member/listCouponWithHistoryByCardNo.json", r),
  getCanReceivedList: r => fly.get("/api/shop/getCanReceivedListNew.json", r),
  // 查询票券平台未使用优惠券
  wechatShareConfig: r => fly.get("/api/wechat/platform/share/wechatShareConfig.json", r),
  secondRushTimeSlot: (r) => fly.get('/api/shop/secondRushTimeSlot.json', r),
  //抢购场次下的商品
  secondRushTimeSlotGoods: (r) => fly.get('/api/shop/secondRushTimeSlotGoods.json', r),
  // 限时抢购商品详情
  // 获取退款原因列表
  getRefundReasonList: (r) => fly.get('/api/cms/codebase/listCodeBase.json?parentCode=refundReason'),
  // 申请退款
  doOrderRedund: (r) => fly.post('/api/shop/oderRefund.json?orderNo=' + r.orderNo, r),
  // 商品订单点评添加
  addOrderComment: r => fly.post('/api/shop/addComment.json', r),
  // 套票优惠券
  listAvailableCombinationCoupon: r => fly.get("/api/member/listAvailableCombinationCoupon.json", r),
  // 查询商城的产品券
  myShopGoodsCode: r => fly.get("/api/shop/myShopGoodsCode.json", r),
  // 通过shareId反查优惠券信息
  getCouponByShareId: r => fly.get("/api/coupon/getCouponByShareId.json", r),
  // 通过券号反查优惠券信息
  findCouponDetailByCoupon: r => fly.get("/api/member/findCouponDetailByCoupon.json", r),
  	// 通过券号反查多张优惠券信息
	findCouponDetailListByCouponNo: r => fly.get("/api/member/findCouponDetailListByCouponNo.json", r),
  //取消退款
  notRefund: r => fly.get("/api/shop/notRefund.json", r),
  //获取券适用酒店
  getCouponSuitHotel: r => fly.get("/api/shop/getCouponSuitHotel.json", r),
  //取消（撤销）预约
  revokeOnlineReserve: r => fly.get("/api/shop/revokeOnlineReserve.json", r),
  //加价说明
  getShopOnlineReserveConfig: r => fly.get("/api/shop/getShopOnlineReserveConfig.json", r),
  //预约
  submitOnlineReserve: r => fly.post("/api/shop/submitOnlineReserve.json", r),
  //预售列表接口
  getShopActivityGoodsList: r => fly.get("/api/shop/getShopActivityGoodsList.json", r),
  //预售详情接口
  getShopActivityGoodsInfo: r => fly.get("/api/shop/getShopActivityGoodsInfo.json", r),
  //更新订单地址信息
  updateShopOrderAddress: (r) => fly.post('/api/shop/updateShopOrderAddress.json', r),
  //获取入账酒店
  getHotelInfo: (r) => fly.get('/api/shop/getHotelInfo.json', r),
  //获取短链接
  getShortUrl: (r) => fly.get('/api/wechat/platform/getShortUrl.json', r),
  // 通过套票反查套票信息
  listCombinationBase: r => fly.get("/api/member/listCombinationBase.json", r),
  // 分销中心
  myDistributionCenter: r => fly.get("/api/distribution/myDistributionCenter.json", r),
  // 根据套票号获取详情
  findCouponOwnerCombinationDtoByPackageNo: r => fly.get("/api/member/findCouponOwnerCombinationDtoByPackageNo.json", r),
  // 获取配置
  getMultiSysOptionCommonForHigh: r => fly.get("/api/cache/sysOptions/getMultiSysOptionCommonForHigh.json", r),
  //门店商城
  getFromOriginal: r => fly.get("/api/shop/getFromOriginal.json", r),
  // 获取支付配置
  findShopPayConfig: r => fly.get("/api/shop/findShopPayConfig.json", r),
  //获取聚合首页数据
  	// 根据券号查询转赠中的shareid
	getPresentCouponDetailByCouponNo: r => fly.get("/api/coupon/getPresentCouponDetailByCouponNo.json", r),
  // 获取商城可用券
  getAvaliableCouponCodes: r => fly.get("/api/shop/getAvaliableCouponCodes.json", r),
  aggregatePage: r => fly.get('/api/shop/aggregatePage.json', r),
  // 查询送出的优惠券
  queryGiftCoupon4Platform: r => fly.get("/api/coupon/queryGiftCoupon4Platform.json", r),
  // 查询送出的商品券
  myShopGoodsCodeTransfer: r => fly.get("/api/shop/myShopGoodsCodeTransfer.json", r),
  //获取奖励金列表
  listShareRewardRecord: r => fly.get("/api/shop/listShareRewardRecord.json", r),
  //获取奖励金总数
  totalRecord: r => fly.get("/api/shop/totalRecord.json", r),
  //查询码的商品信息
  searchCodeMessage: r => fly.get("/api/shop/searchCodeMessage.json", r),
  //核销-码
  writeOff: r => fly.get("/api/shop/writeOff.json", r),
  newWriteOff: r => fly.post("/api/shop/newWriteOff.json", r),
  //获取支付方式
  limitPayment: r => fly.get("/api/shop/limitPayment.json", r),
  //聚合页领取优惠券
  receiveSCCouponNew: r => fly.post("/api/shop/receiveSCCouponNew.json?" + r.url,r),
  getCouponDetail: (r) => fly.get('/api/shop/getCouponDetail.json', r),
  //券详细信息查询
  couponDeatil: (r) => fly.get('/api/shop/couponDeatil.json', r),
  //获取核销点信息
  listCombinationConsumptionSite: (r) => fly.get('/api/shop/listCombinationConsumptionSite', r),
  //生成token
  getToken: r => fly.get("/api/member/getToken.json", r),
  //通过token解析
  getMemberInfoByToken: r => fly.get("/api/member/getMemberInfoByToken.json", r),
  getMemberUpgradeInfo: r =>
    fly.get("/api/member/getMemberUpgradeInfo.json", r),
  getInvoiceSwitch: r => fly.get("/api/invoice/getInvoiceSwitch.json", r),

  //添加收藏
  addGoodsCollection: (r) => fly.post('/api/shop/addGoodsCollection.json', r),
  //我的收藏
  getGoodsCollection: (r) => fly.get('/api/shop/getGoodsCollection.json', r),
  //删除收藏
  deleteGoodsCollection: (r) => fly.post('/api/shop/deleteGoodsCollection.json', r),
  //查询商品是否收藏
  getGoodsIsCollection: (r) => fly.get('/api/shop/getGoodsIsCollection.json', r),
  //生成模版
  addShopCustomTemplate: (r) => fly.post('/api/shop/addShopCustomTemplate.json', r),
  //获取模版
  template: (r) => fly.get('/api/shop/template.json', r),
  //会员中心订单数，收藏数
  getOrderAnalysisAndCollect: (r) => fly.get('/api/shop/getOrderAnalysisAndCollect.json', r),
  // 核销码扫描轮询接口(票券)
  findCouponStaByCouponNos: (r) => fly.get('/api/member/findCouponStaByCouponNos.json', r),
  //获取支付信息
  queryPayOrderInfo: r => fly.post('/api/pay/queryPayOrderInfo.json', r),
  //获取首页模板
  shopIndePage: (r) => fly.get('/api/shop/shopIndePage.json', r),
  //获取主题色
  shopStyleConfig: (r) => fly.get('/api/shop/shopStyleConfig.json', r),
  //首单信息
  firstOrderInfo: (r) => fly.get('/api/shop/firstOrderInfo.json', r),
  //过滤聚合页商品列表
  shopGoodsTemplate: (r) => fly.get('/api/shop/shopGoodsTemplate.json', r),
  //查询区域列表
  findGcZoneList: (r) => fly.get('/api/hotel/findGcZoneList.json', r),
  //预约信息
  shopOnlineReserveInfo: (r) => fly.get('/api/shop/shopOnlineReserveInfo.json', r),
  //预约审核
  examineShopOnlineReserve: (r) => fly.get('/api/shop/examineShopOnlineReserve.json', r),
  cancelTransferShareInfo: (r) => fly.get('/api/shop/cancelTransferShareInfo.json', r),
  //撤销转赠
  cancelReceiveGiftCoupon4Platform: (r) => fly.get('/api/coupon/cancelReceiveGiftCoupon4Platform.json', r),
  //批量查询门票商品信息
  listProductByGoodsCode: (r) => fly.post('/api/hotel/listProductByGoodsCode.json', r),
  //批量查询组合商品信息
  listQueryPackDailyDetail: (r) => fly.get('/api/hotel/listQueryPackDailyDetail.json', r),
  //获取集团下聚合页分组
  selectHotelGroupAggregate: (r) => fly.get('/api/shop/selectHotelGroupAggregate.json', r),
  getGoodsShareRate: (r) => fly.get('/api/shop/getGoodsShareRate.json', r),
  //购物车更新自提点
  updateShopCartPickUpPoint: (r) => fly.post('/api/shop/updateShopCartPickUpPoint?' + r.url, r),
  //开盲盒
  boxSplitOrder: (r) => fly.get('/api/shop/boxSplitOrder.json', r),
  getOrderInvoiceSta: (r) => fly.get('/api/invoice/getOrderInvoiceSta.json', r),
  getInvoiceOrder: (r) => fly.get('/api/invoice/getInvoiceOrder.json', r),
  //获取会员码
  generatePayCodeForCard: (r) => fly.get('/api/member/generatePayCodeForCard.json', r),
  //充值卡充值
  rechargeCoupon: (r) => fly.post('/api/shop/rechargeCoupon.json?couponNo=' + r.couponNo + '&cardNo=' + r.cardNo + '&couponCode=' + r.couponCode + '&hotelGroupCode=' + r.hotelGroupCode, r),
  //聚合页组合商品信息
  queryPackDailyDetailForHomePage: (r) => fly.get('/api/hotel/queryPackDailyDetailForHomePage.json', r),
  //获取在线预约商品库存
  getGoodStock: (r) => fly.get('/api/shop/getGoodStock.json', r),
  //获取在线预约商品sku
  getGoodsSkuInfo :(r) => fly.get('/api/shop/getGoodsSkuInfo.json', r),
  //批量获取商品详情
  goodsDetailList :(r) => fly.get('/api/shop/goodsDetailList.json', r),
  //交易快照
  getShopOrderSnapshopt:(r) => fly.get('/api/shop/getShopOrderSnapshopt.json', r),
  //获取自定义底部
  getShopButtonConfig:(r) => fly.get('/api/shop/getShopButtonConfig.json', r),
  //获取城市天气
	getWetherList:(r) => fly.get('/api/area/getWetherList.json', r),
  //获取种草笔记分页
	listShopPlantingNotes:(r) => fly.get('/api/shop/listShopPlantingNotes.json', r),
  //种草笔记详情
  getShopPlantingNotesInfo :(r) => fly.get('/api/shop/getShopPlantingNotesInfo.json', r),
  //种草笔记点评
  addShopPlantingNotesComment:(r) => fly.post('/api/shop/addShopPlantingNotesComment.json', r),
  //评价点赞
	commentLike: (r) => fly.get('/api/shop/commentLike.json', r),
	//取消点赞
	cancelCommentLike: (r) => fly.get('/api/shop/cancelCommentLike.json', r),
  //种草笔记点赞
  shopPlantingNotesLike: (r) => fly.get('/api/shop/shopPlantingNotesLike.json', r),
  //种草笔记取消点赞
  cancelShopPlantingNotesLike: (r) => fly.get('/api/shop/cancelShopPlantingNotesLike.json', r),
  //批量获取种草笔记详情
  getShopPlantingNotesInfoList :(r) => fly.get('/api/shop/getShopPlantingNotesInfoList.json', r),
  //获取城市天气
  getShopActivityInfo:(r) => fly.get('/api/shop/getShopActivityInfo.json', r),
  //根据距离取最优二维码
  findWeHotelQrCodeById: (r) => fly.get('/cpwechatapi/weHotelQrCode/H5/findWeHotelQrCodeById', r),
  //根据活码随机取群二维码
  findGroupCodeById: (r) => fly.get('/cpwechatapi/weGroupCode/H5/findGroupCodeById', r),
  //获取地址列表
	getAreaInfo: (r) => fly.get('/api/area/info.json', r),
  //关闭强制提醒
  setCloseForceDialogConfigCache: (r) => fly.get('/api/shop/setCloseForceDialogConfigCache.json', r),
  //获取关闭强制提醒
  getCloseForceDialogConfigCache: (r) => fly.get('/api/shop/getCloseForceDialogConfigCache.json', r),
  //物流公司
  selectShopDeliveryCompanyInfo: (r) => fly.get('/api/shop/selectShopDeliveryCompanyInfo.json', r),
  //回寄信息
  refundDeliveryOrder  : (r) => fly.post('/api/shop/refundDeliveryOrder.json', r),

  queryCardPointBalanceWithUnionGroup: (r) => fly.post('/api/member/queryCardPointBalanceWithUnionGroup.json', r),

  submitSaasApplyRecord: (r) => fly.post('/api/shop/submitSaasApplyRecord.json', r),
  getCardList: r => fly.get("/api/member/getCardList.json", r),
  selectApplyRecordByOpenid: (r) => fly.get('/api/shop/selectApplyRecordByOpenid.json', r),
  detailList:(r) => fly.get('/shopapi/aggregateTypeGoods/detailList.json', r),
  listAllGoodsDetailByParent:(r) => fly.get('/shopapi/aggregateTypeGoods/listAllGoodsDetailByParent.json', r),
  checkCanSubmit:(r) => fly.get('/api/shop/checkCanSubmit.json', r),
  selectShopExchageGoodsInfo:(r) => fly.get('/api/shop/selectShopExchageGoodsInfo.json', r),
  shopExchageGoods:(r) => fly.post('/api/shop/shopExchageGoods.json', r),
  queryCommentPresetConfig: (r) => fly.post('/api/member/queryCommentPresetConfig', r),
  listCommentPreset: (r) => fly.get('/api/shop/listCommentPreset', r),
  queryHotelStoredName: (r) => fly.post('/api/member/queryHotelStoredName.json', r),
  getCanTriggerRuleList: (r) => fly.post('/api/shop/getCanTriggerRuleList.json', r),
  getCanReceiveCouponList: (r) => fly.post('/api/shop/getCanReceiveCouponList.json?hotelGroupCode=' + r.hotelGroupCode +'&memberId='+r.memberId, r),
  getCategroyByCode: (r) => fly.get('/api/cms/category/getCategroyByCode', r),
  categoryViews: (r) => fly.get('/api/cms/category/'+r.id+'/views.json', r),
  refreshMemberInfo: r => fly.get("/api/member/refreshMemberInfo.json", r),
  deliveryMessageItemAjax: r => fly.get("/api/shop/deliveryMessageItemAjax.json", r),
  getGuideByGoodsId: r => fly.get("/hotelapi/journeyGuide/getGuideByGoodsId", r),
  	//获取可用优惠券列表
	listAvaliableGoods: (r) => fly.get('/api/shop/listAvaliableGoods.json', r),
  checkMobileImgCode: r => fly.get("/api/member/checkMobileImgCode.json", r),
  queryCompanyInfo: r => fly.post("/api/company/queryCompanyInfo.json?" + r),
  getGuideByCode: r => fly.get("/hotelapi/journeyGuide/getGuideByCode.json", r),
  getShopGoodsDiyDetailById:r => fly.get("/shopapi/shopGoodsDiyDetail/getShopGoodsDiyDetailById.json", r),
  getHotelCouponReserveAcitivityList: (r) => fly.get('/api/shop/getHotelCouponReserveAcitivityList.json', r),
	queryRoomExtra: (r) => fly.post('/api/hotel/queryRoomExtra.json', r),
	getHotelCouponReserveRecordList: (r) => fly.get('/api/shop/getHotelCouponReserveRecordList.json', r),
  receiveTriggerRuleCoupon: (r) => fly.get('/api/shop/receiveTriggerRuleCoupon', r),//获取优惠券
  canReceiveCouponList: (r) => fly.get('/api/shop/getCanReceiveCouponList', r),//获取优惠券详情
  selectShareRecord: (r) => fly.post('/api/distribution/selectShareRecord', r),//门票奖励金
  getShopShareInfoByOpenId: (r) => fly.get('/api/shop/getShopShareInfoByOpenId', r),
  getShopShareMessageByOpenId : (r) => fly.get('/api/shop/getShopShareMessageByOpenId', r),
  developFansHFive : (r) => fly.get('/api/distribution/developFansHFive.json', r),
  getMemberRight: (r) => fly.get('/api/shop/getMemberRight', r),
  receiveMemberRightCoupon: (r) => fly.post('/api/shop/receiveMemberRightCoupon.json', r),
  getMemberRightCoupon: (r) => fly.get('/api/shop/getMemberRightCoupon.json', r),
  extraComment: (r) => fly.post('/api/shopComment/extraComment.json', r),
  saveOrUpdateShopPlantingNotes: (r) => fly.post('/api/shop/saveOrUpdateShopPlantingNotes.json', r),
  listShopPlantingNotesLike: (r) => fly.get('/api/shop/listShopPlantingNotesLike.json', r),
  deleteShopPlantingNotes: (r) => fly.post('/api/shop/deleteShopPlantingNotes.json?id='+r.id, r),
  listShopPlantingNotesAuthor: (r) => fly.get('/api/shop/listShopPlantingNotesAuthor.json', r),
  saveShopPlantingAuthor: (r) => fly.post('/api/shop/saveShopPlantingAuthor.json', r),
  interfaceTransfer: (r) => fly.post("/api/sync/interfaceTransfer.json", r),
  batchSubmitOnlineReserve : (r) => fly.post('/api/shop/batchSubmitOnlineReserve', r),
  syncUploadImageBatch: (r) => fly.post('/api/shop/syncUploadImageBatch?hotelGroupCode=GCBZG', r),
  getSignature: (r) => fly.get('/shopapi/tencentSignature/getSignature', r),
  deleteOrder : (r) => fly.post('/api/shop/deleteOrder?orderNo='+r.orderNo, r),
  isDistributor: (r) => fly.get('/api/distribution/isDistributor.json', r),
  findAggregateTypeGoodsTotal: (r) => fly.get('/shopapi/aggregateType/findAggregateTypeGoodsTotal', r),
  pageSysOption: (r) => fly.post('/hotelapi/distributionNew/pageSysOption', r),
  selectBlindBoxOpenRewardInfo: r => fly.get("/api/shop/selectBlindBoxOpenRewardInfo.json", r),
  getCityinfo: (r) =>fly.get('/service/BaiduApi/baiduAk', r),
  findCityCodeByDes: (r) => fly.get('/api/area/findCityCodeByDes', r),
  selectVague: r => fly.post("/hotelapi/hotelInvoice/selectVague", r),
  queryPreOrderInvoiceSta: r => fly.post("/api/invoice/queryPreOrderInvoiceSta.json", r), // 获取预申请开票状态
  saveOrderPreInvoice: r => fly.get("/api/invoice/saveOrderPreInvoice", r), // 保存当前订单的预申请发票信息
  queryOrderPreInvoice: r => fly.get("/api/invoice/queryOrderPreInvoice", r), // 查询当前订单的预申请发票记录
  batchSubmitOrder: (r) => fly.post('/api/shop/batchSubmitOrder.json', r),
  queryCityTree: (r) => fly.get('/shopapi/shopCommon/queryCityTree', r),
  getCityList: r => fly.get("/api/area/info.json", r),
  hotCity: r => fly.get("/api/area/hotCity.json", r),
  getAdvancedSearch: r => fly.get("/api/hotel/selectCodeAndDescript.json", r),
  getYxyWxCodeUrl: (r) => fly.post('/api/microSoftWare/admin/getYxyWxCodeUrl.json', r), //获取又湘游海报
  queryGoodsTypeNameByGoodsId: (r) => fly.get('/api/shop/queryGoodsTypeNameByGoodsId', r),
  getGcDistributorBase: (r) =>fly.get('/api/distribution/getGcDistributorBase.json', r),
  listProductsMultiType: (r) => fly.post('/shopapi/aggregateProduct/listProductsMultiType', r),
  queryActivityTriggerConfigByRecharge: (r) => fly.get('/api/member/queryActivityTriggerConfigByRecharge', r),
  findActivityUrlByCode: (r) => fly.get('/activityapi/wechatActivity/findActivityUrlByCode', r), // 根据活动code查找活动链接
  renjiget: (r) => fly.post('/baseapi/captcha/get', r), //renji
  renjicheck: (r) => fly.post('/baseapi/captcha/check', r), //renji
}

export default api;



// WEBPACK FOOTER //
// ./src/utils/api.js